import {Component, Input, OnInit} from '@angular/core';
import {ErrorInfo} from '../../shared/model/error-info';
import {TranslatePipe} from '@ngx-translate/core';
import {TargetBlankDirective} from 'commons';
import {MatCard} from '@angular/material/card';
import {MatIcon} from '@angular/material/icon';


@Component({
    selector: 'myupdates-error-box',
    templateUrl: './error-box.component.html',
    styleUrls: ['./error-box.component.scss'],
    imports: [MatCard, TargetBlankDirective, TranslatePipe, MatIcon]
})
export class ErrorBoxComponent implements OnInit {
  @Input() errorTitle?: string;
  @Input() errorText?: string;
  @Input() errorInfo?: ErrorInfo;
  @Input() showServiceTimeNotice = true;

  ngOnInit(): void {
    if (this.errorTitle === undefined) {
      this.errorTitle = 'Fehlermeldung';
      this.errorText = this.errorInfo?.errorText;
    }
  }

}
